import { Trash2, UserCheck } from 'lucide-react';
import { formatRoleName } from '../../../../../data/roleManagement/roleManagementData';

const RoleMemberMobileCard = ({ member, currentUserRole, onDelete }) => {
  const canDelete =
    currentUserRole === 'admin' ||
    (currentUserRole === 'subadmin' && member.role !== 'admin' && member.role !== 'subadmin');

  return (
    <div className="p-4 space-y-3 bg-white hover:bg-slate-50/50 transition-colors">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-full bg-teal-50 text-[#067978] border border-teal-100 flex items-center justify-center overflow-hidden font-bold text-xs flex-shrink-0 shadow-sm">
            {member.email ? member.email.charAt(0).toUpperCase() : 'U'}
          </div>
          <div className="min-w-0">
            <h4 className="text-xs font-semibold text-slate-800 truncate" title={member.email}>
              {member.email}
            </h4>
            <div className="text-[11px] text-slate-400 font-medium truncate flex items-center gap-1 mt-0.5">
              <UserCheck size={11} className="text-slate-400 flex-shrink-0" />
              <span>{formatRoleName(member.role)}</span>
            </div>
          </div>
        </div>

        {canDelete && (
          <button
            onClick={() => onDelete(member._id, member.role, member.email)}
            className="p-2 text-rose-500 hover:bg-rose-50 rounded-xl transition-all cursor-pointer"
            title="Remove team member"
          >
            <Trash2 size={16} />
          </button>
        )}
      </div>

      <div className="flex items-center justify-between text-xs pt-2 border-t border-slate-50">
        <div>
          {member.role === 'admin' ? (
            <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-purple-50 text-purple-600 border border-purple-100/60">
              ADMIN
            </span>
          ) : member.role === 'subadmin' ? (
            <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-indigo-50 text-indigo-600 border border-indigo-100/60">
              SUB-ADMIN
            </span>
          ) : member.role === 'bookings' ? (
            <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-sky-50 text-sky-600 border border-sky-100/60">
              BOOKINGS
            </span>
          ) : (
            <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-amber-50 text-amber-600 border border-amber-100/60">
              OPERATIONS
            </span>
          )}
        </div>

        <div className="text-slate-500 font-mono text-[11px]">{member.phone_number || 'N/A'}</div>

        <span className="inline-flex items-center text-xs font-bold text-emerald-600">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 mr-1.5"></span>
          Active
        </span>
      </div>
    </div>
  );
};

export default RoleMemberMobileCard;
